import { call, put, takeLatest } from "redux-saga/effects";
import {
  onPostPointReversal,
  onPostPointReversalError,
  onPostPointReversalSuccess,
} from "../Store/Slices/pointReversalSlice";
import { pointReversalPostApi } from "../Context/pointsReversal";

function* PostPointReversal({ payload }) {
  try {
    const postPointReversalResponse = yield call(pointReversalPostApi, payload);
    if (postPointReversalResponse.httpStatusCode === "200") {
      yield put(
        onPostPointReversalSuccess({
          data: postPointReversalResponse.response,
          message: postPointReversalResponse.errorMessage,
          status_code: postPointReversalResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onPostPointReversalError({
          data: postPointReversalResponse.response,
          message: postPointReversalResponse.response.message,
          status_code: postPointReversalResponse.httpStatusCode,
        })
      );
    }
  } catch (error) {
    const message = error.response.data.errorMessage || "Something went wrong";
    yield put(
      onPostPointReversalError({ data: [], message, status_code: 400 })
    );
  }
}
export default function* pointReversalSaga() {
  yield takeLatest(onPostPointReversal.type, PostPointReversal);
}
